/**
 * 一份新谱的初始内容。
 *
 * 两处共用：访客第一次进编辑器（`TestApp.tsx`）与云端「＋ 新建曲谱」（`saas/LibraryPage.tsx`）。
 * 它们原本各写各的，改一处忘一处的话，注册用户看到的反而是更差的那份。
 *
 * 内容刻意不是"空骨架"而是**带注释的教学样张**：第一次打开的人得先看出
 * 左边是能改的文本、右边是它的排版结果，才知道从哪儿下手。
 * 谱子取自 `public/examples/小星星.spnmn` 的第一句 —— 用的是真实可渲染的内容，
 * 不是手写的示意，所以打开就能试听。
 *
 * 样张**不带曲名**（不写 `Dt:`）。新谱本来就没名字，硬塞一个「小星星」会让
 * 保存流程以为"名字已经有了"，取名框永不弹，最后库里躺着一份名叫《小星星》
 * 但其实不是小星星的谱。曲名由保存流程问用户要（见 `docTitle.ts`）。
 *
 * ⚠️ 注释用**整行 `//`**，不用行末注释。整行注释在解析器里等同空白行
 *    （`parser.ts` 的 lns2clns：剥掉行末 comment token 后只剩 eof，直接返回 undefined）；
 *    行末注释虽然也会被剥离，但 `P:` 的属性解析走 token 切片，风险不值得冒。
 */

export function makeDefaultScore(title?: string): string {
	// 没给名字就**不写 `Dt:`** —— 新谱本来就没有名字，让它保持"无标题"这个
	// 真实状态，保存时宿主才知道该问用户要名字（`TestApp.saveToCloud`）。
	// 以前这里塞了个占位名「小星星」：新建一份谱、随便写点东西、保存，
	// 库里就多出一份叫《小星星》但其实不是小星星的谱，而且因为"已经有名字了"
	// 连取名框都不会弹 —— 名字错了还没机会改。
	const clean = title?.replace(/[\r\n]+/g, ' ').trim() ?? ''
	const titleLine = clean ? `Dt: ${clean}\n` : ''
	return `// 这是一份简谱源码：左边改字，右边立刻重排。
// 以 // 开头的整行是注释，不会印到谱面上。

// 调号与拍号写在 P 行；曲名用 Dt: 一行写，不写也行 —— 保存时会问你。
${titleLine}P: 1=C 4/4
====

// 数字是音名；- 表示延长一拍；| 是小节线
N: 1 1 5 5 | 6 6 5 - | 4 4 3 3 | 2 2 1 - |
// 这行是歌词，一个字对一个音
Lc: 一闪一闪亮晶晶，满天都是小星星。
`
}
